import { apiReq } from "../utils/api/apiReq";

export async function signInWithTeams(teamsToken: string) {
  // Token is set by the server using the set-cookie header
  const response = await apiReq<{ csrfToken: string }>("POST", "/v1/signIn/teams", { token: teamsToken });
  const { csrfToken } = response.data;

  return csrfToken;
}

export async function validateDomain(domain: string) {
  await apiReq("GET", `/v1/signIn/domain/${domain}`);
}
